module.exports = __webpack_public_path__ + "static/media/logo-google-cloud.89fca129.png";